import { Logo } from '@components/core';
import { Cell, makeGrid } from '@components/grid';
import { media } from '@helpers/media_templates';
import * as React from 'react';
import styled from 'styled-components';
import { Body, BodyWrapper } from './body_wrapper';

const FooterWrapper = styled(Body)`
  background-color: ${props => props.theme.footer};

  * {
    font-family: primary-bold;
  }
`;

const FooterGrid = styled(makeGrid('div'))`
  align-items: flex-start;
  margin: auto;
  grid-template-areas:
    'logo . . .'
    'contact contact socialLinks socialLinks'
    'legalLinks legalLinks copyright copyright';

  ${media.medium`
    grid-template-areas:
      'logo logo . . . .'
      'contact socialLinks legalLinks legalLinks copyright copyright'
  `}

  ${media.large`
    grid-template-areas:
      'logo logo . . . . . . . . . .'
      'contact contact socialLinks socialLinks legalLinks legalLinks legalLinks . . . copyright copyright';
  `}
`;

const FooterCell = styled(Cell)`
  margin-bottom: 20px;
  line-height: 20px;
  font-size: 14px;
  color: ${props => props.theme.footerText};

  a {
    display: block;
    text-decoration: none;
    color: ${props => props.theme.footerText};
  }
`;

const CopyrightCell = styled(FooterCell)`
  text-align: right;
`;

const Copyright = styled.small`
  display: block;

  ${media.medium`
    text-align: right;
  `}
`;

const Footer = props => {
  return (
    <BodyWrapper>
      <FooterWrapper>
        <FooterGrid>
          <FooterCell area="logo">
            <Logo />
          </FooterCell>
          <CopyrightCell area="copyright">
            <Copyright>© 2024</Copyright>
            <Copyright>All rights reserved</Copyright>
          </CopyrightCell>
        </FooterGrid>
      </FooterWrapper>
    </BodyWrapper>
  );
};

export default Footer;
